export default {
	sessionId: state => state.sessionId,
	subscriptionReady: state => state.subscriptionReady,
	vinImportEvent: state => state.vinImportEvent,
	createFromDraftEvent: state => state.createFromDraftEvent,
	isCreateFromDraftModalOpen: state => state.isCreateFromDraftModalOpen
}
